const linkStyles = {
  liStyle:{
    display: "inline",
    margin:0,
  },
  buttonStyle:{
    padding:"16px",
    cursor: "pointer",
    textAlign: "left",
    letterSpacing: ".323px",
    color: "#292929",
    fontSize: "0.95em",
    backgroundColor:"transparent",
    width:"100%",
    fontFamily: "Roboto, sans-serif",
    lineHeight: "24px",
    borderWidth:"0",
    fontWeight:"400",
    
  },
  linkStyle:{
    display:"block",
    textDecoration: "none",
    fontFamily: "Roboto, sans-serif",
    fontWeight: "400",
    wordBreak:"break-word",
    border:"none",
    lineHeight:"24px",
    padding:"16px",
  },
}

export default linkStyles;
